import { motion } from "framer-motion";
import { WHY } from "@/data/site";
import { MaskedLineInView } from "@/components/Reveal";

export default function WhyUs() {
  return (
    <section
      data-testid="why-section"
      className="relative py-28 md:py-40 border-t border-slate-100 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative mb-20 md:mb-28 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <motion.div
            aria-hidden="true"
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.6, ease: [0.2, 0.7, 0.15, 1] }}
            className="pointer-events-none absolute -top-8 left-0 md:-left-16 md:-top-14 w-[380px] md:w-[560px] h-[220px] md:h-[300px] -z-0 overflow-hidden rounded-[45%]"
            style={{ filter: "blur(34px)", opacity: 0.45 }}
          >
            <img
              src="https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?auto=format&fit=crop&w=1600&q=60"
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/50 to-white" />
          </motion.div>
          <div className="relative z-10 md:col-span-7">
            <div className="text-xs uppercase tracking-[0.24em] text-blue-600 font-semibold">/ Manifesto</div>
            <h2 className="mt-4 font-display text-4xl md:text-6xl font-light tracking-tight text-slate-900 leading-[1.02]">
              <MaskedLineInView>Data as</MaskedLineInView>{" "}
              <MaskedLineInView delay={0.1}>
                <span className="font-serif-editorial italic">infrastructure</span>,
              </MaskedLineInView>
              <br />
              <MaskedLineInView delay={0.2}>not a spreadsheet.</MaskedLineInView>
            </h2>
          </div>
          <div className="relative z-10 md:col-span-4 md:col-start-9 text-base md:text-lg text-slate-600 leading-relaxed">
            Six ideas we defend. Six ways we keep the promise of premium business data — clean,
            compliant and shaped to your ICP.
          </div>
        </div>

        <div className="space-y-0">
          {WHY.map((w, i) => (
            <motion.article
              key={w.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.2, 0.7, 0.15, 1] }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-t border-slate-100"
              data-testid={`why-item-${i}`}
            >
              <div className="md:col-span-3">
                <div className="chapter-numeral text-8xl md:text-[9rem] transition-all duration-700 group-hover:[-webkit-text-stroke:1px_#2563eb]">
                  {w.n}
                </div>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-slate-900">
                  {w.title}
                </h3>
              </div>
              <div className="md:col-span-5">
                <p className="text-base md:text-lg text-slate-600 leading-relaxed">{w.body}</p>
              </div>
            </motion.article>
          ))}
          <div className="border-t border-slate-100" />
        </div>
      </div>
    </section>
  );
}
